import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '../store'

import Layout from '@/views/layout'

Vue.use(VueRouter)

const routes = [
  {
    path:'/test',
    name: 'Test',
    component: () => import('@/views/test.vue'),
  },
  // 大屏数据
  {
    path: '/screen',
    name: 'Screen',
    component: () => import('@/views/screen/index'),
    hidden: true,
  },
  // 邀请
  {
    path: '/collect',
    name: 'Collect',
    component: () => import('@/views/collect/index'),
    hidden: true,
  },
  // 打印
  {
    path: '/printer',
    name: 'Printer',
    component: () => import('@/views/activity/components/countPrintView.vue'),
    hidden: true,
  },
  // 三优评比
  {
    path: '/TEA',
    name: 'TEA',
    redirect: '/TEA/index',
    component: () => import('@/views/TEA/layout'),
    children: [
      {
        path: 'index',
        name: 'TEAindex',
        component: () => import('@/views/TEA/index'),
      }
    ]
  },
  // 问卷测评
  {
    path: '/wj/:id',
    name: 'opennedWJ',
    props: true,
    component: () => import('@/views/WJ/wj-home-page'),
    hidden: true,
  },
  // 外部学习
  {
    path: '/wb-study',
    name: 'WBstudy',
    component: () => import('@/views/study/wb-details.vue'),
    hidden: true,
  },
  {
    path: '/',
    name: '',
    redirect: 'login',
  },
  // 登录
  {
    path: '/login',
    name: 'Login',
    component: ()=> import('@/views/login/index'),
    hidden: true
  },
  // 账户信息
  {
    path: '/',
    component: Layout,
    redirect: '/accountInfo',
    alwaysShow: true,
    children: [
      {
        path: 'accountInfo',
        name: 'AccountInfo',
        component: () => import('@/views/accountInfo/index'),
        meta: { title: '账户信息', icon: 'el-icon-user', affix: true }
      }
    ]
  },
  // 首页
  {
    path: '/',
    component: Layout,
    redirect: '/home',
    children: [
      {
        path: 'home',
        name: 'Home',
        component: () => import('@/views/home/index'),
        meta: { title: '首页', icon: 'el-icon-s-home', affix: true }
      }
    ]
  },
  // 管理中心
  {
    path:'/basic',
    name:'basic',
    redirect: '/basic/menu',
    component: Layout,
    alwaysShow: true,
    meta: {
      title: '管理中心',
      icon: 'el-icon-coin',
    },
    children: [
      {
        path: 'menu',
        name: 'Menu',
        component: () => import('@/views/system/menu'),
        meta: { title: '菜单管理', icon: 'el-icon-menu'}
      },
      {
        path: 'role',
        name: 'Role',
        component: () => import('@/views/system/role'),
        meta: { title: '角色管理', icon: 'el-icon-s-custom'}
      },
      {
        path: 'expert',
        name: 'Expert',
        component: () => import('@/views/basic/expert.vue'),
        meta: { title: '专家管理', icon: 'el-icon-s-line'}
      },
      {
        path: 'school',
        name: 'School',
        component: () => import('@/views/basic/schools'),
        meta: { title: '学校管理', icon: 'el-icon-school'}
      },
      {
        path: 'class',
        name: 'Class',
        component: () => import('@/views/basic/class'),
        meta: { title: '班级管理', icon: 'el-icon-class'}
      },
      {
        path: 'teacher',
        name: 'Teacher',
        component: () => import('@/views/basic/teachers'),
        meta: { title: '教师管理', icon: 'el-icon-user-solid'}
      },
      {
        path: 'staff',
        name: 'Staff',
        component: () => import('@/views/basic/staff'),
        meta: { title: '教研员管理', icon: 'el-icon-s-custom'}
      },
      /**
       * 量表管理
       * **/
      // 评价量表
      {
        path: 'evalEmbu',
        name: 'evalEmbu',
        component: () => import('@/views/basic/embu.vue'),
        meta: { title: '评价量表', icon: 'el-icon-s-custom'}
      },
      // 课程量表
      {
        path: 'lessonEmbu',
        name: 'lessonEmbu',
        component: () => import('@/views/basic/lessonEmbu.vue'),
        meta: { title: '课堂评价量表', icon: 'el-icon-s-custom'}
      },
      // 学校课程量表
      {
        path: 'schoolLessonEmbu',
        name: 'schoolLessonEmbu',
        component: () => import('@/views/basic/schoolLessonEmbu.vue'),
        meta: { title: '学校课堂评价量表', icon: 'el-icon-s-custom'}
      },
      /**
       * 三优评比管理
       * **/
      // 三优评比-主活动
      {
        path: 'teaMain',
        name: 'TEAMainCreat',
        component: () => import('@/views/basic/TEA/main'),
        meta: { title: '三优评比主活动创建', icon: 'el-icon-s-custom'}
      },
      // 三优评比-子活动
      {
        path: 'teaSub',
        name: 'TEASubCreat',
        component: () => import('@/views/basic/TEA/sub'),
        meta: { title: '三优评比子活动创建', icon: 'el-icon-s-custom'}
      },
      /**
       * 问卷测评
       * **/ 
      // 问卷测评-指标维度
      {
        path: 'wjDimension',
        name: 'WJDimension',
        component: () => import('@/views/basic/dimension.vue'),
        meta: { title: '指标维度', icon: 'el-icon-s-operation'}
      },
      // 问卷测评-指标题库
      {
        path: 'wjQuestion',
        name: 'WJQuestion',
        component: () => import('@/views/basic/question.vue'),
        meta: { title: '指标题库', icon: 'el-icon-s-management'}
      },
      // 问卷测评-问卷管理
      {
        path: 'wj',
        name: 'QuestionView',
        component: () => import('@/views/WJ/wj-page'),
        meta: { title: '问卷管理', icon: 'el-icon-wenjuanguanli', activeMenu:'/basic/wjQuestion'}
      },
    ]
  },
  // 资源中心
  {
    path: '/resource',
    component: Layout,
    // redirect: '/resource/index',
    children: [
      {
        path: 'index',
        name:'Resource',
        component: () => import('@/views/resource/index'),
        meta: { title: '全部资源', icon: 'el-icon-resource', keepAlive: true }
      },
      {
        path: 'detail',
        name:'ResourceDetail',
        component: () => import('@/views/resource/details'),
        meta: { title: '资源详情', icon: 'el-icon-resource' }
      },
      {
        path: 'expert-detail',
        name:'ExpertResourceDetail',
        component: () => import('@/views/resource/expertDetails'),
        meta: { title: '专家资源详情', icon: 'el-icon-resource' }
      },
      {
        path: 'edit',
        name:'ResourceEdit',
        component: () => import('@/views/resource/edit'),
        meta: { title: '资源编辑', icon: 'el-icon-resource' }
      },
      {
        path: 'addition',
        name:'ResourceAddition',
        component: () => import('@/views/resource/addition'),
        meta: { title: '资源上传', icon: 'el-icon-resource' }
      },
      {
        path: 'study',
        name:'ResourceStudy',
        component: () => import('@/views/resource/study'),
        meta: { title: '内部资源', icon: 'el-icon-resource' }
      },
      {
        path: 'added',
        name:'ResourceAdded',
        component: () => import('@/views/resource/added'),
        meta: { title: '资源上传', icon: 'el-icon-resource' }
      }
    ]
  },
  // 活动中心
  {
    path:'/activity',
    name:'activity',
    redirect: '/activity/expert',
    component: Layout,
    alwaysShow: true,
    meta: {
      title: '活动中心',
      icon: 'el-icon-coin',
    },
    children: [
      {
        path: 'expert',
        name: 'ActivityExpert',
        component: () => import('@/views/activity/experts'),
        meta: { title: '往期活动', icon: 'el-icon-user-solid'}
      },
      {
        path: 'expertDetail',
        name: 'ExpertDetail',
        component: () => import('@/views/activity/expertDetails'),
        meta: { title: '专家活动详情', icon: 'el-icon-user-solid', activeMenu:'/activity/expert'}
      },
      {
        path: 'themeDetail',
        name: 'ThemeDetail',
        component: () => import('@/views/activity/themeDetails'),
        meta: { title: '主题活动详情', icon: 'el-icon-user-solid', activeMenu:'/activity/expert'}
      },
      {
        path: 'teacher',
        name: 'ActivityTeacher',
        component: () => import('@/views/activity/teachers'),
        meta: { title: '研修任务', icon: 'el-icon-user-solid'}
      },
      {
        path: 'uploadOpus',
        name: 'UploadOpus',
        component: () => import('@/views/activity/uploadOpus'),
        meta: { title: '上传资源素材', icon: 'el-icon-user-solid', activeMenu:'/activity/teacher'}
      },
      {
        path: 'schoolUpload',
        name: 'SchoolUpload',
        component: () => import('@/views/activity/schoolUpload'),
        meta: { title: '上传资源素材', icon: 'el-icon-user-solid', activeMenu:'/activity/teacher'}
      },
      {
        path: 'wjconfig',
        name: 'WJconfig',
        component: () => import('@/views/activity/WJconfig'),
        meta: { title: '问卷任务配置', icon: 'el-icon-user-solid', activeMenu:'/activity/teacher'}
      },
      {
        path: 'report',
        name: 'ActivityReport',
        component: () => import('@/views/activity/report'),
        meta: { title: '任务统计报告', icon: 'el-icon-user-solid'}
      },
    ]
  },
  // 专家评审
  {
    path: '/reviewed',
    component: Layout,
    // redirect: '/resource/index',
    children: [
      {
        path: 'index',
        name:'Reviewed',
        component: () => import('@/views/reviewed/index'),
        meta: { title: '研修任务评审', icon: 'el-icon-review' }
      },
      {
        path: 'teacher',
        name:'ReviewTeacher',
        component: () => import('@/views/reviewed/teachers'),
        meta: { title: '评审列表', icon: 'el-icon-review' }
      },
      {
        path: 'audited',
        name:'ReviewAudited',
        component: () => import('@/views/reviewed/audited'),
        meta: { title: '评审', icon: 'el-icon-review' }
      },
      {
        path: 'matching',
        name:'ReviewMatch',
        component: () => import('@/views/reviewed/matching'),
        meta: { title: '评审任务分配', icon: 'el-icon-review' }
      },
      {
        path: 'counting',
        name:'ReviewCount',
        component: () => import('@/views/reviewed/counting'),
        meta: { title: '统计', icon: 'el-icon-s-data' }
      },
      {
        path: 'results-enter',
        name:'ReviewResultsEnter',
        component: () => import('@/views/reviewed/resultsEnter'),
        meta: { title: '结果录入', icon: 'el-icon-review' }
      },
      {
        path: 'tentative',
        name:'ReviewFilter',
        component: () => import('@/views/reviewed/tentative'),
        meta: { title: '研修任务初筛', icon: 'el-icon-document' }
      },
      {
        path: 'tentative/list',
        name:'ReviewFilterList',
        component: () => import('@/views/reviewed/tentativeList'),
        meta: { title: '初筛列表', icon: 'el-icon-document', keepAlive: false }
      },
      {
        path: 'TEA-PS',
        name:'TEA-PS',
        component: () => import('@/views/reviewed/TEA-PS'),
        meta: { title: '三优活动初筛', icon: 'el-icon-document' }
      },
      {
        path: 'TEA-Eval',
        name:'TEA-Eval',
        component: () => import('@/views/reviewed/TEA-Eval'),
        meta: { title: '三优活动评审', icon: 'el-icon-document' }
      },
    ]
  },
  // 学习任务
  {
    path: '/study',
    component: Layout,
    children: [
      {
        path: 'index',
        name:'Study',
        component: () => import('@/views/study/index'),
        meta: { title: '学习任务', icon: 'el-icon-school'}
      },
      {
        path: 'list',
        name:'StudyList',
        component: () => import('@/views/study/list'),
        meta: { title: '列表', icon: 'el-icon-school', keepAlive: true }
      },
      {
        path: 'detail',
        name:'StudyDetail',
        component: () => import('@/views/study/details'),
        meta: { title: '详情', icon: 'el-icon-school' }
      },
    ]
  },
  // 思维课堂
  {
    path:'/curriculum',
    name:'curriculum',
    redirect: '/curriculum/index',
    component: Layout,
    children: [
      // 课程管理
      {
        path: 'index',
        name: 'curriculumIndex',
        component: () => import('@/views/lesson/index'),
      },
      // 评课管理
      {
        path: 'course',
        name: 'curriculumCourse',
        component: () => import('@/views/lesson/course'),
      },
      // 报告管理
      {
        path: 'reporting',
        name: 'curriculumReporting',
        component: () => import('@/views/lesson/reporting'),
      },
      // 评委点评详情
      {
        path: 'details',
        name: 'curriculumDetails',
        component: () => import('@/views/lesson/details'),
      },
      // 评课报告
      {
        path: 'report',
        name: 'curriculumReport',
        component: () => import('@/views/lesson/report'),
      },
      
      // 阶段分析报告列表
      {
        path: 'phaseReport',
        name: 'curriculumPhaseReport',
        component: () => import('@/views/lesson/phaseReportList'),
        meta: { title: '阶段分析报告' }
      },
      // 教师个人课堂教学报告
      {
        path: 'teacherReport/:id',
        name: 'curriculumTeacherReport',
        component: () => import('@/views/lesson/teacherReport'),
        meta: { title: '教师个人课堂教学报告', activeMenu: '/curriculum/phaseReport' }
      },
      // 学校整体课堂教学报告
      {
        path: 'schoolReport/:id',
        name: 'curriculumSchoolReport',
        component: () => import('@/views/lesson/schoolReport'),
        meta: { title: '学校整体课堂教学报告', activeMenu: '/curriculum/phaseReport' }
      },
      // 区域整体课堂教学报告
      {
        path: 'regionReport/:id',
        name: 'curriculumRegionReport',
        component: () => import('@/views/lesson/regionReport'),
        meta: { title: '区域整体课堂教学报告', activeMenu: '/curriculum/phaseReport' }
      },
    ]
  },
  // 思维课堂评价
  {
    path: '/lesson',
    name: 'LESSON',
    redirect: '/lesson/comment',
    component: () => import('@/views/lesson/layout'),
    children: [
      {
        path: 'comment',
        name:'lessonComment',
        component: () => import('@/views/lesson/comment'),
      }
    ]
  },
  // 报告（按年份组织，后续扩展 2026 年直接在 children 中追加即可）
  {
    path: '/report',
    component: Layout,
    children: [
      // 2025 年报告
      {
        path: '2025/area',
        name: 'AreaReport2025',
        component: () => import('@/views/report/2025/area'),
        meta: { title: '区域报告' }
      },
      {
        path: '2025/school',
        name: 'SchoolReport2025',
        component: () => import('@/views/report/2025/school'),
        meta: { title: '学校报告' }
      },
      {
        path: '2025/annual',
        name: 'AnnualReport2025',
        component: () => import('@/views/report/2025/annual'),
        meta: { title: '年度统计' }
      },
      // 2026 年报告
      {
        path: '2026/school',
        name: 'SchoolReportList2026',
        component: () => import('@/views/report/2026/schoolList'),
        meta: { title: '学校报告列表' }
      },
      {
        path: '2026/school/detail',
        name: 'SchoolReportDetail2026',
        component: () => import('@/views/report/2026/school'),
        meta: { title: '学校报告详情' }
      },
      {
        path: '2026/area',
        name: 'AreaReport2026',
        component: () => import('@/views/report/2026/area'),
        meta: { title: '区域报告' }
      }
    ]
  }
]

const router = new VueRouter({
  mode: "history",
  routes,
  scrollBehavior: () => ({ y: 0 }),
})

router.beforeEach((to, from, next) => {
  // console.error(to, from, '=== created == beforeEach ===');
  const matcheds = to.matched||[];
  const {name} = matcheds[0]||{};
  // 路由源
  if(to.name=='lessonComment'){
    store.dispatch('setRouteSource', to);
  }
  // 添加缓存页面
  const names = store.getters.keepAlivePageName;
  if (to.name==='Resource'&&!names.includes('Resource')) {
    store.dispatch('setKeepAlivePageName', [...names, 'Resource']);
  }
  const otherRouterNames = [
    'ExpertDetail',
    'ThemeDetail',
    'UploadOpus',
    'SchoolUpload',
    'WJconfig',
    'ResourceDetail',
    'ExpertResourceDetail',
    'ResourceEdit',
    'ResourceAddition',
    'ResourceAdded',
    'ReviewTeacher',
    'ReviewAudited',
    'ReviewCount',
    'ReviewFilterList',
    'ReviewResultsEnter',
    'StudyList',
    'StudyDetail',
    'AccountInfo',
    'Collect',
    'Printer',
    'WBstudy',
    'Screen',
    'opennedWJ',
    'QuestionView',
    'curriculumReport',
    'curriculumPhaseReport',
    'curriculumTeacherReport',
    'curriculumSchoolReport',
    'curriculumRegionReport',
    'curriculumDetails',
    'Test',
    'SchoolReportList2026',
    'SchoolReportDetail2026',
  ];
  // 报告类路由名称规则：AreaReport2025、SchoolReport2026、AnnualReport2027 等
  const reportNameRegex = /^(Area|School|Annual)Report\d{4}$/;
  if(otherRouterNames.includes(to.name) || reportNameRegex.test(to.name)){
    to.meta.activeMenu = from.meta.activeMenu||from.path||to.meta.activeMenu;
  }
  // !/.*\/collect\/.*/.test(to.path)
  if (to.name != 'Login' && !localStorage.getItem("token") && to.name != 'Collect' && !['TEA','WBstudy','Screen','opennedWJ'].includes(name)) {
    next({
      name: 'Login'
    });
  } else {
    const { menu } = store.state;
    if (!otherRouterNames.includes(to.name) && !reportNameRegex.test(to.name) && to.name != 'Login' && menu && !hasValue(menu, to.path) && name!='TEA' && name!='LESSON'&& name!='opennedWJ') {
      next('/home');
      // Message.error({
      //   message:"暂无权限访问！",
      // });
      return false;
    }
    next();
  }
})

const hasValue = (arr=[], target='') =>{
  for (let i = 0; i < arr.length; i++) {
    const item = arr[i];
    if (item.uri === target) {
      return true;
    } else if (Array.isArray(item.childs)) {
      if (hasValue(item.childs, target)) {
        return true;
      }
    }
  }
  return false;
}

export default router

